import PropTypes from "prop-types";
import React from "react";

export function HeroRequest({ singlePackage }) {
	if (singlePackage) {
		return null;
	}

	return (
		<div className="hero__request well well--inverted grid">
			<div className="request grid__col-12 grid__col-sm-7">
				<p className="title">
					Need more than one account? Choose team plan
				</p>
				<div className="description">
					Get our news subscription for a team. Volutpat a, massa
					tortor, neque ut. Diam nisl magna tellus elementum lobortis
					nulla cras id habitant.
				</div>
				<a
					className="btn btn--primary w-min-20"
					href="mailto:sales@ch-aviation.com"
				>
					Send a request
				</a>
			</div>
			<div className="features typography grid__col-12 grid__col-sm-5">
				<p className="title">Special features:</p>
				<ul className="ticks ticks--small">
					<li>Add more than one account</li>
					<li>Multi-year contracts</li>
					<li>Custom price</li>
				</ul>
			</div>
		</div>
	);
}

HeroRequest.propTypes = {
	singlePackage: PropTypes.bool.isRequired,
};
